import LayoutChild from "@/layouts/LayoutChild.vue";
import LayoutArticle from "@/layouts/LayoutArticle.vue";

export default [
  // 
  {
    path: "/search-detail",
    name: "search-detail",
    meta: {
      title: "搜索",
      hidden: true,
    },
    component: LayoutArticle,
    // redirect: "",
    children: [{
      path: "/search/detail",
      name: "search_detail",
      meta: {
        title: "详情",
      },
      component: () => import("@/views/search/detail.vue"),
    }, ],
  },
  {
    path: "/search",
    name: "search",
    meta: {
      title: "搜索",
      hidden: true
    },
    component: LayoutChild,
    // redirect: "",
    children: [{
      path: "/search/result",
      name: "search_result",
      meta: {
        title: "",
      },
      component: () => import("@/views/search/search-result.vue"),
    }, ],
  },
];